import { render, staticRenderFns } from "./NewEditGestaoDeAulaPageGeral.vue?vue&type=template&id=7f2c5a73"
import script from "./NewEditGestaoDeAulaPageGeral.vue?vue&type=script&lang=js"
export * from "./NewEditGestaoDeAulaPageGeral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports